// extracted by mini-css-extract-plugin
export var blue = "_12-g";
export var brand = "_12-c";
export var darkGrey = "_12-f";
export var disabled = "_12-6";
export var disabledSubtle = "_12-7";
export var error = "_12-8";
export var green = "_12-h";
export var grey = "_12-e";
export var icon = "_12-0";
export var inherit = "_12-b";
export var lightGrey = "_12-d";
export var orange = "_12-j";
export var pink = "_12-l";
export var primary = "_12-1";
export var purple = "_12-m";
export var quaternary = "_12-4";
export var quinary = "_12-5";
export var red = "_12-k";
export var secondary = "_12-2";
export var success = "_12-a";
export var tertiary = "_12-3";
export var warning = "_12-9";
export var white = "_12-n";
export var yellow = "_12-i";